const INITIALIZE_COLLECTION = "populateCollection";
const ADD_COLLECTION_ITEM = "addCollectionItem";
const REMOVE_COLLECTION_ITEM = "removeCollectionItem";
const ADD_COLLECTION_HOOK = "addCollectionHook";

export default {
	state: () => ({
		ids: [],
		path: [],
		hooks: {
			add: [],
			remove: [],
		},
		base: {
			state: {},
			module: {},
		},
	}),
	getters: {
		list: (state, getters, rootState) => {
			const parentState = state.path.reduce((reducedState, path) => reducedState[path], rootState);
			return state.ids.reduce((list, id) => ({ ...list, [id]: parentState[id] }), {});
		},
		array: (state, getters) => Object.values(getters.list),
		ordered: (state, getters) => getters.array.sort((itemA, itemB) => itemA.order - itemB.order),
	},
	actions: {
		populate({ dispatch, commit }, collection) {
			commit(INITIALIZE_COLLECTION, collection);

			Object.values(collection.items).forEach((item) => {
				dispatch("add", item);
			});
		},
		add(context, item) {
			context.commit(ADD_COLLECTION_ITEM, item);
			context.state.hooks.add.forEach((handler) => {
				handler(context, item);
			});
		},
		remove(context, item) {
			context.commit(REMOVE_COLLECTION_ITEM, item);
			context.state.hooks.remove.forEach((handler) => {
				handler(context, item);
			});
		},
		createHook({ commit }, hook) {
			commit(ADD_COLLECTION_HOOK, hook);
		},
	},
	mutations: {
		[ADD_COLLECTION_HOOK](state, hook) {
			state.hooks[hook.type].push(hook.handler);
		},
		[INITIALIZE_COLLECTION](state, collection) {
			state.path = Array.isArray(collection.path) ? collection.path : collection.path.split("/");
			state.base.state = typeof collection.module.state === "function" ? collection.module.state() : collection.module.state;
			state.base.module = collection.module;
		},
		[ADD_COLLECTION_ITEM](state, item) {
			state.ids.push(item.id);
			const module = { ...state.base.module, state: { ...state.base.state, ...item } };
			this.registerModule([...state.path, item.id], module);
		},
		[REMOVE_COLLECTION_ITEM](state, item) {
			const index = state.ids.findIndex((id) => id === item.id);
			state.ids.splice(index, 1);
			this.unregisterModule([...state.path, item.id]);
		},
	},
};
